import { render, staticRenderFns } from "./randot_jump.score.vue?vue&type=template&id=4d6ab6d0&scoped=true"
import script from "./randot_jump.score.vue?vue&type=script&lang=js"
export * from "./randot_jump.score.vue?vue&type=script&lang=js"
import style0 from "./randot_jump.score.vue?vue&type=style&index=0&id=4d6ab6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6ab6d0",
  null
  
)

export default component.exports